import { FormRadioBar } from "@jsq/ds/forms";
import * as styles from "./styles_vanilla.css";

interface Props {
  readonly: boolean;
  isFull?: boolean;
}

const DocumentStatusRadioBar = ({ readonly, isFull }: Props) => {
  return (
    <FormRadioBar
      name="documentStatus"
      size={isFull ? "small" : "medium"}
      isFullWidth={isFull}
      className={isFull ? undefined : styles.narrowRadioBar}
      options={[
        { label: "Verified", value: "verified", isDisabled: readonly },
        { label: "Not valid", value: "invalid", isDisabled: readonly },
      ]}
    />
  );
};

export default DocumentStatusRadioBar;
